import { Button } from "@mui/material";
import styled from "styled-components";
import { AppColors } from "../../Styles/colors";

export const LabelButtonMes = styled(Button)`
    scroll-margin-top: 7.5vh;
    font-weight: 700;
    justify-content: start;
    font-size: 1em;
    padding: 1px 10px;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 2px solid ${AppColors.blueMiddle};

    &:active, &:hover{
        box-shadow: none;
        background-color: #545454ff;
    }

    ${(props) =>
        props.variant === "outlined" &&
        `
        background-color: transparent;
        border: 2px solid #545454ff;
    `}

    ${(props) =>
        props.variant === "contained" &&
        `
        background-color: #545454ff;
        border-radius: 5px;
        text-decoration: none;
        padding: 2px 10px;
        color: white;
        border: none;

        &.active{
        background-color: #1d9e8cff;
    }
    `}

    ${(props) =>
        props.size === "small" &&
        `
        font-size: 0.8em;
    `}
`
